namespace nsc {
    function startAnimation(this: HTMLElement) {
        this.classList.add(this.dataset.animationClass!);
    }

    function restartAnimation(this: HTMLElement) {
        this.classList.remove(this.dataset.animationClass!);
        void this.offsetWidth;
        setTimeout(startAnimation.bind(this), 0);
    }

    const animatedElements = document.querySelectorAll<HTMLElement>("[data-animation-interval]");

    for (let i = 0; i < animatedElements.length; i++) {
        const element = animatedElements.item(i);

        const interval = parseInt(element.dataset.animationInterval!, 10);

        if (isNaN(interval)) {
            continue;
        }

        if (element.dataset.animationClass === undefined) {
            element.dataset.animationClass = "animated";
        }

        setInterval(restartAnimation.bind(element), interval);
    }

    export function scrollToElement(element: HTMLElement | string) {
        if (element === "") {
            return;
        }

        const target = typeof element == "string"
            ? document.querySelector<HTMLElement>(element)
            : element;

        if (target === null) {
            return;
        }

        const header = document.querySelector<HTMLElement>("header.sticky-top");

        if (header === null) {
            return;
        }

        const clientRect = target.getBoundingClientRect();

        window.scrollBy(0, clientRect.top - header.offsetHeight);

        return true;
    }

    function hashChangeEventListener(this: Window, event: HashChangeEvent) {
        if (scrollToElement(location.hash)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    window.addEventListener("hashchange", hashChangeEventListener);

    function loadEventListener(this: Window, event: Event) {
        scrollToElement(location.hash);
    }

    window.addEventListener("load", loadEventListener, { once: true });

    type ListEntry = [string, string];
    interface ListsDictionary {
        [name: string]: ListEntry[];
    }

    let listsRequest: JQueryXHR | undefined;

    export function fetchDropdownLists(): Promise<ListsDictionary> {
        if (listsRequest === undefined) {
            listsRequest = $.getJSON("/api/dropdowns");
        }

        return listsRequest as any;
    }

    $("select[data-list]").each(function () {
        this.setAttribute("disabled", "");

        while (this.hasChildNodes()) {
            this.removeChild(this.lastChild!);
        }

        const loadingIndicator = document.createElement("option");

        loadingIndicator.textContent = "Loading...";
        loadingIndicator.innerText = loadingIndicator.textContent;

        this.appendChild(loadingIndicator);

        fetchDropdownLists().then((data: ListsDictionary) => {
            const list = data[this.dataset.list!];

            if (list === undefined) {
                return;
            }

            this.removeChild(loadingIndicator);

            for (const entry of list) {
                const option = document.createElement("option");

                option.setAttribute("value", entry[0]);
                option.textContent = entry[1];
                option.innerText = entry[1];

                if (this.dataset.default && this.dataset.default === entry[0]) {
                    option.setAttribute("selected", "")
                }

                this.appendChild(option);
            }

            this.removeAttribute("disabled");
        });
    });

    $("fieldset[data-checkbox-list]").each(function () {
        const ignoreValue = !!this.dataset.ignoreValue;

        fetchDropdownLists().then((data: ListsDictionary) => {
            const list = data[this.dataset.checkboxList!];

            if (list === undefined) {
                return;
            }

            const name = this.dataset.name!;

            let filterPattern: RegExp | undefined;

            if (this.dataset.filterRegex !== undefined) {
                filterPattern = new RegExp(this.dataset.filterRegex, "i");
            }

            let index = this.children.length;

            for (const entry of list) {
                if (filterPattern !== undefined && !filterPattern.test(entry[1])) {
                    continue;
                }

                const inputId = name + "_" + index;

                const input = document.createElement("input");

                input.setAttribute("type", "checkbox");
                input.setAttribute("class", "form-check-input");
                input.setAttribute("name", name);
                input.setAttribute("id", inputId);

                if (!ignoreValue) {
                    input.setAttribute("value", entry[0]);
                } else {
                    input.setAttribute("value", entry[1].replace(/,/g, "%2C"));
                }

                const label = document.createElement("label");

                label.setAttribute("class", "form-check-label");
                label.setAttribute("for", inputId);
                label.innerText = label.textContent = entry[1];

                const wrapper = document.createElement("div");

                wrapper.setAttribute("class", "form-check");

                wrapper.appendChild(input);
                wrapper.appendChild(label);

                this.appendChild(wrapper);

                // Carry the validation attributes over from the fieldset to
                // the first input

                if (index === 0) {
                    if (this.hasAttribute("required")) {
                        input.setAttribute("required", "");
                    }

                    if (this.hasAttribute("minlength")) {
                        input.setAttribute("minlength", this.getAttribute("minlength")!);
                    }

                    if (this.dataset.msg) {
                        input.setAttribute("data-msg", this.dataset.msg)
                    }
                }

                index++;
            }
        });
    });

    const backdrop = document.getElementById("backdrop")!;

    export function showBackdrop() {
        document.body.style.overflowY = "hidden";
        backdrop.style.display = "block";
    }

    export function hideBackdrop() {
        document.body.style.overflowY = "auto";
        backdrop.style.display = "";
    }

    export function getURLParameter(name: string, defaultValue: string | null = null) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);

        return results === null
            ? defaultValue
            : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    export function getReferralId(defaultValue = "") {
        let referralId = getURLParameter("ref");

        if (referralId !== null) {
            return referralId;
        }

        referralId = getURLParameter("affid");

        if (referralId !== null) {
            return referralId;
        }

        return defaultValue;
    }

    export function arraysAreEqual<T>(array1: T[], array2: T[]): boolean {
        if (array1.length !== array2.length) {
            return false;
        }

        for (let i = 0; i < array1.length; i++) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }

        return true;
    }

    let cookies: { [name: string]: string } | undefined = undefined;

    export function getCookie(name: string) {
        if (cookies === undefined) {
            cookies = {};

            const segments = document.cookie.split(";");

            for (const segment of segments) {
                const parts = segment.split("=");
                const name = parts[0];
                const value = parts[1];
                cookies[name] = value;
            }
        }

        return cookies[name];
    }

    let httpMethod: string;

    jQuery.ajaxPrefilter((options: JQuery.AjaxSettings, originalOptions: JQuery.AjaxSettings, xhr: JQuery.jqXHR) => {
        httpMethod = (options.type || "GET").toUpperCase();
    });

    $(document).ajaxError((event: JQuery.TriggeredEvent, xhr: JQueryXHR) => {
        const origin = xhr.readyState < 4 ? "network" : "server";

        if (httpMethod === "POST") {
            displayError(`ajax-error-${origin}-post`);
        } else {
            displayError(`ajax-error-${origin}`);
        }
    });

    window.addEventListener("error", () => {
        displayError("javascript-error");
    });

    $("button.reload-page").on("click", () => {
        location.reload();
    });

    function displayError(id: string) {
        $(".system-error").addClass("d-none");
        $("#" + id).removeClass("d-none");
        window.scrollTo(0, 0);
        window.onbeforeunload = null;
    }

    export function createBlob(data: any, contentType?: string) {
        let blob: Blob | undefined = undefined;

        try {
            const options = contentType ? { type: contentType } : undefined;
            blob = new Blob([data], options)
        } catch (e) {
        }

        if (blob === undefined) {
            const blobBuilder = new BlobBuilder();
            blobBuilder.append(data);
            blob = blobBuilder.getBlob(contentType);
        }

        return blob;
    }

    export function sendBeacon(url: string, data: any, contentType?: string) {
        let beaconQueued = false;

        if (navigator.sendBeacon) {
            // createBlob() might throw, and so could sendBeacon()
            try {
                // Chrome refuses to send non-plain-text beacons.
                const payload = /Chrome\/\d/.test(navigator.userAgent)
                    ? createBlob(data, "text/plain")
                    : createBlob(data, contentType);

                beaconQueued = navigator.sendBeacon(url, payload);
            } catch (e) {
                console.log("sendBeacon():", e);
            }
        }

        console.log("sendBeacon(): beaconQueued=" + beaconQueued);

        if (!beaconQueued) {
            jQuery.post({ url, data, contentType });
        }
    }

    function saveClick() {
        const ignore = new RegExp("^https?://" + location.host + "/");

        // Return early if this is not an external click
        if (!document.referrer || ignore.test(document.referrer)) {
            return;
        }

        const data = {
            referrer: document.referrer,
            url: location.href
        };

        sendBeacon("/saveclick.cfm", JSON.stringify(data), "application/json");
    }

    saveClick();
}
